export default "__VITE_ASSET__9ae148c4__"